import { render, staticRenderFns } from "./CustomerUserDetails.vue?vue&type=template&id=6debd2ec"
import script from "./CustomerUserDetails.vue?vue&type=script&lang=js"
export * from "./CustomerUserDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports